// Dummy social proof + trust content. Replace text/images later — nothing here
// is wired to a backend, so real reviews/photos can drop straight in.
import { IMAGES } from "./content";

export const PRICE_FROM = "₹19,900";

export const RATING = { score: "4.8", count: 512 };

export const STATS = [
  { value: "4.8★", label: "Average rating" },
  { value: "500+", label: "Bathrooms delivered" },
  { value: "100%", label: "Size-checked orders" },
  { value: "Jaipur", label: "Installation support" },
];

// TODO: replace with real customer reviews/photos when available.
// Avatars render as initials until real customer photos are supplied.
export const TESTIMONIALS = [
  {
    name: "Ananya Sharma",
    city: "Jaipur",
    rating: 5,
    product: "Aurelia Wall-Mounted Vanity",
    quote:
      "They confirmed my exact wall width on WhatsApp before dispatch. It fit perfectly — no guesswork, no returns.",
  },
  {
    name: "Rohan Mehta",
    city: "Udaipur",
    rating: 5,
    product: "Aurelia Wall-Mounted Vanity",
    quote:
      "Genuinely premium finish for the price. Dispatch timeline was exactly what they promised.",
  },
  {
    name: "Priya Nair",
    city: "Jaipur",
    rating: 5,
    product: "Aurelia Wall-Mounted Vanity",
    quote:
      "Installation support in Jaipur made it effortless. Felt like buying from a specialist, not a marketplace.",
  },
];

// TODO: replace with real 'installed in customer bathroom' photography.
export const INSTALL_PHOTOS = [
  { src: IMAGES.hero, alt: "Vanity installed in a modern bathroom" },
  { src: IMAGES.wall, alt: "Wall mounted vanity in a customer's home" },
  { src: IMAGES.floor, alt: "Floor mounted vanity styled in a bathroom" },
  { src: IMAGES.p2, alt: "Close-up of a fitted vanity" },
];

// Consolidated, evidence-led promise strip (replaces the old repeated blocks).
export const PROMISES = [
  {
    n: "01",
    title: "Size-checked before dispatch",
    copy: "We confirm width, depth and clearances against your bathroom — free, before anything ships.",
  },
  {
    n: "02",
    title: "Transparent, all-in pricing",
    copy: "Prices are inclusive of taxes with honest dispatch timelines shown up front. No hidden charges.",
  },
  {
    n: "03",
    title: "Secure payments & damage cover",
    copy: "Encrypted checkout and a clear shipping-and-damage process if anything arrives less than perfect.",
  },
  {
    n: "04",
    title: "Vanity-only specialists",
    copy: "We do two things — wall mounted and floor mounted vanities — and we do them properly.",
  },
];
